import { useQuery } from "@tanstack/react-query";
import { api } from "../../api";

export function useGetUserGroup(groupId: string | undefined) {
  return useQuery({
    queryKey: ["user-groups", groupId],
    queryFn: () => api.getUserGroup(groupId!),
    enabled: !!groupId,
  });
}
